import React from 'react';
import i18next from 'i18next';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import Dropzone from 'react-dropzone';
import { FormControl } from 'react-bootstrap';
import { FiTrash2 } from "react-icons/fi";
import { documentsService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import { trackHaddockDocumentUpload } from "utils/posthogTracking";

class EmployeeDocumentsUploadModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			submitted: false,
			errors: {},
			files: [],
			customNames: {} // Nuevo estado para manejar nombres personalizados
		};
	}

	handleSubmit = async event => {
		event.preventDefault();

		this.setState({ isLoading: true });
		let response = '';

		const { folderId, employeeId } = this.props;
		const { files } = this.state;

		if (files.length > 0) {
			// Usar archivos con nombres personalizados
			const filesWithCustomNames = this.createFilesWithCustomNames();
			response = await documentsService.uploadAttachments(folderId, employeeId, filesWithCustomNames);
		} else {
			this.props.handleClose();
		}

		if (response.ok) {
			this.setState({ 
				isLoading: false,
				errors: {},
			}, () => {
				trackHaddockDocumentUpload(this.props.user, {
					document_count: files.length,
					upload_mode: "employee_profile",
					employee_id: employeeId,
					source: "employee_profile",
				});
				toastr.success(i18next.t('common.success'), i18next.t('employeeDocuments.uploadSuccess'));
				
				if (this.props.onUploadSuccess) {
					this.props.onUploadSuccess();
				}
			});
		} else {
			this.setState({ 
				isLoading: false,
				submitted: true,
				errors: errorFormating(response)
			});
		}
	}  

	onDrop = (files) => {
		// Inicializar nombres personalizados para los nuevos archivos
		const customNames = { ...this.state.customNames };
		files.forEach(file => {
			const fileKey = `${file.name}-${file.lastModified}`;
			if (!customNames[fileKey]) {
				// Extraer nombre y extensión
				const lastDotIndex = file.name.lastIndexOf('.');
				const nameWithoutExt = lastDotIndex > 0 ? file.name.substring(0, lastDotIndex) : file.name;
				const extension = lastDotIndex > 0 ? file.name.substring(lastDotIndex) : '';
				customNames[fileKey] = nameWithoutExt;
			}
		});

		this.setState({ files, customNames });
	}	

	removeFile = (file) => {
		const { files, customNames } = this.state;
		const fileKey = `${file.name}-${file.lastModified}`;
		
		// Crear nueva copia de customNames sin el archivo eliminado
		const newCustomNames = { ...customNames };
		delete newCustomNames[fileKey];

		this.setState({
			files: files.filter(f => f.lastModified !== file.lastModified),
			customNames: newCustomNames
		});
	}

	// Nueva función para manejar cambios en nombres personalizados
	handleCustomNameChange = (file, newName) => {
		const { customNames } = this.state;
		const fileKey = `${file.name}-${file.lastModified}`;
		
		this.setState({
			customNames: {
				...customNames,
				[fileKey]: newName
			}
		});
	};

	// Función para obtener el nombre final del archivo (nombre personalizado + extensión)
	getFinalFileName = (file) => {
		const { customNames } = this.state;
		const fileKey = `${file.name}-${file.lastModified}`;
		const customName = customNames[fileKey] || '';
		
		// Extraer extensión del archivo original
		const lastDotIndex = file.name.lastIndexOf('.');
		const extension = lastDotIndex > 0 ? file.name.substring(lastDotIndex) : '';
		
		return customName + extension;
	};

	// Función para crear archivos con nombres personalizados
	createFilesWithCustomNames = () => {
		const { files } = this.state;
		return files.map(file => {
			const finalName = this.getFinalFileName(file);
			// Crear un nuevo archivo con el nombre personalizado
			return new File([file], finalName, { type: file.type });
		});
	};

	getDropzone = () => {
		const files = this.state.files.length > 0 && this.state.files.map((file, i) => {
			var size = file.size/1000000;
			var sizeLetters = "Mb";

			if (size < 1){
				size = file.size/1000;
				sizeLetters = "Kb";
			}	

			// Extraer extensión del archivo original
			const lastDotIndex = file.name.lastIndexOf('.');
			const extension = lastDotIndex > 0 ? file.name.substring(lastDotIndex) : '';
			const fileKey = `${file.name}-${file.lastModified}`;
			const customName = this.state.customNames[fileKey] || '';

			return (
				<li className="file-item-temp" key={i}>
					<div className="file-info" title={file.name}>
						<div className="file-name-section">
							<span className="file-name">{file.name}</span>
							<span className="file-size">({size.toFixed(2)}{sizeLetters})</span>
						</div>
						<div className="custom-name-section">
							<FormControl
								type="text"
								placeholder={i18next.t('employeeDocuments.customNamePlaceholder')}
								value={customName}
								onChange={(e) => this.handleCustomNameChange(file, e.target.value)}
								className="custom-name-input"
							/>
							<span className="file-extension">{extension}</span>
						</div>
					</div>
					<div className="file-action">	
						<button 
							type="button" 
							className="btn btn-icon" 
							title={i18next.t('common.delete')}
							onClick={() => this.removeFile(file)}
						>
							<FiTrash2/>
						</button>
					</div>
				</li>
			);
		});	

		return(
			<Dropzone onDrop={this.onDrop}>
				{({getRootProps, getInputProps}) => (
					<section className="dropzone-container">
						<div {...getRootProps({className: 'dropzone'})}>
							<input {...getInputProps()} />
							<p>{i18next.t('employeeDocuments.dropzoneText')}</p>
						</div>
						<ul className="dropzone-files">
							{files}
						</ul>
					</section>
				)}
			</Dropzone>
		);
	}

	render() {
		return(
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					{this.getDropzone()}
				</div>     

				<div className="modal-footer">
					<button 
						type="button" 
						onClick={this.props.handleClose} 
						className="btn btn-outline-primary"
					>
						{i18next.t('common.cancel')}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={i18next.t('employeeDocuments.btnUpload')}
						loadingText={i18next.t('employeeDocuments.btnUploading')}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (state) => ({
	user: state.authReducer?.user,
});

export default connect(mapStateToProps)(EmployeeDocumentsUploadModal); 